import { render, staticRenderFns } from "./shouruWayZB.vue?vue&type=template&id=57a62948&scoped=true&"
import script from "./shouruWayZB.vue?vue&type=script&lang=js&"
export * from "./shouruWayZB.vue?vue&type=script&lang=js&"
import style0 from "./shouruWayZB.vue?vue&type=style&index=0&id=57a62948&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a62948",
  null
  
)

export default component.exports